import {DOCUMENT_STATE_UPDATE} from "../actions/documentStatesActions";

const INITIAL_STATE = {
  documentStates: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DOCUMENT_STATE_UPDATE:
      return {
        ...state,
        documentStates: [...action.payload],
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/documents/reducers/DocumentStatesReducer.js